import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import moment from "moment";
import MarkdownIt from "markdown-it";
import {
  Box,
  Typography,
  Paper,
  Chip,
  Divider,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DescriptionIcon from "@material-ui/icons/Description";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import LabelIcon from "@material-ui/icons/Label";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ModalReport from './comp/ModalReport'


const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: 900,
    margin: "0 auto",
    padding: theme.spacing(3),
  },
  header: {
    marginBottom: theme.spacing(3),
    paddingBottom: theme.spacing(1.5),
  },
  reportCard: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    borderRadius: 12,
    background: "#fff",
    boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
    transition: "0.25s",
    "&:hover": {
      boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
      transform: "translateY(-2px)",
    },
  },
  reportTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },
  rowLine: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
    color: "#555",
    fontSize: 14,
  },
  icon: {
    fontSize: 18,
    marginRight: 8,
    color: "#1976d2",
  },
  tagChip: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  descriptionBox: {
    marginTop: theme.spacing(2),
    color: "#333",
    lineHeight: 1.6,
  },
  seeMoreBtn: {
    marginTop: theme.spacing(2),
    textTransform: "none",
  },
}));

const md = new MarkdownIt({
  html: true,
  linkify: true,
  breaks: true,
});

export default function ReportListPage() {
  const classes = useStyles();
  const history = useHistory();
  const { eventId } = useParams();
  const [event, setEvent] = useState({});
  const [reports, setReports] = useState([]);
  const [selectedReport, setSelectedReport] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    const loadReports = async () => {
      // const baseUrl = `{${process.env.REACT_APP_BACKOFFICE}`
      // const baseUrl = `https://demo-ntw-admin.onwr.go.th`
      // const URL = `http://localhost/one_backoffice/api/v1/public/reportwater/events/report/${eventId}`;
      const URL = `${process.env.REACT_APP_BACKOFFICE}/sssapi/v1/public/reportwater/events/report/${eventId}`;
      const res = await fetch(URL);
      const json = await res.json();
      if (json.success) {
        setEvent(json.event);
        setReports(json.data || []);
      }
    };

    loadReports();
  }, [eventId]);

  const openDetail = (rp) => {
    setSelectedReport(rp);
    setOpenModal(true);
  };


  return (
    <Box className={classes.container}>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        className={classes.headerBox}
      >
        {/* LEFT: TITLE */}
        <Typography variant="h5" className={classes.header}>
          รายงานทั้งหมดของเหตุการณ์ #{eventId} <br />
          {event.event_name}
        </Typography>

        {/* RIGHT: BACK BUTTON */}
        <Button
          variant="outlined"
          color="primary"
          startIcon={<ArrowBackIcon />}
          onClick={() => history.goBack()}
          className={classes.backButton}
        >
          กลับ
        </Button>
      </Box>


      {reports.length === 0 ? (
        <Typography>ไม่มีรายงาน</Typography>
      ) : (
        reports.map((rp) => {
          const tagNames = (rp.tags || []).map((t) => t.name);
          const html = md.render(rp.description || "");
          return (
            <Paper key={rp.id} className={classes.reportCard}>
              {/* Report Title */}
              <Typography variant="h6" className={classes.reportTitle}>
                <DescriptionIcon style={{ marginRight: 6, color: "#d32f2f" }} />
                {rp.report_name}
              </Typography>

              {/* Report Date */}
              <div className={classes.rowLine}>
                <CalendarTodayIcon className={classes.icon} />
                รายงานวันที่:{" "}
                {moment(rp.report_date).format("D MMM YYYY")}
              </div>

              {/* Updated time */}
              <div className={classes.rowLine}>
                <i className="bi bi-clock"></i>&nbsp;
                อัปเดตเมื่อ:{" "}
                {moment(rp.updated_at).format("D MMM YYYY HH:mm")}
              </div>

              {/* Tags */}
              <Divider style={{ margin: "12px 0" }} />
              <div className={classes.rowLine}>
                <LabelIcon className={classes.icon} />
                <strong style={{ marginRight: 8 }}>แท็ก:</strong>
              </div>

              <Box>
                {tagNames.length > 0 ? (
                  tagNames.map((name) => (
                    <Chip
                      key={name}
                      label={name}
                      size="small"
                      className={classes.tagChip}
                      color="primary"
                    />
                  ))
                ) : (
                  <Typography variant="body2" color="textSecondary">
                    ไม่มีแท็ก
                  </Typography>
                )}
              </Box>

              {/* Description */}
              <Box
                component="div"
                sx={{
                  typography: "body2",
                  color: "text.secondary",

                  "& img": {
                    maxWidth: "100%",
                    width: "100%",
                    height: "auto",
                    display: "block",
                  },
                }}
                dangerouslySetInnerHTML={{ __html: html }}
              />

              {/* Button */}
              <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={() => openDetail(rp)}
              >
                ดูรายละเอียดเพิ่มเติม
              </Button>
            </Paper>
          );
        })
      )}
      {/* 🔥 Modal แบบ center component */}
      <ModalReport
        open={openModal}
        onClose={() => setOpenModal(false)}
        report={selectedReport}
      />
    </Box>
  );
}